import { DataOptionsList } from '../../components/select/types'
import { Systems, SYSTEMS_NAMES } from './types'

export const SYSTEMS_OPTIONS: DataOptionsList[] = Object.entries(Systems).map(
  ([, value]) => ({ name: SYSTEMS_NAMES[value], value })
)
